import { ProductList } from "@/components/ProductList";
import { useActiveProject } from "@/features/project/ActiveProject";
import { type NormalizedDrawing } from "@repo/api";
import { Text } from "@repo/skapa";
import { t } from "@repo/translation";

import { useSearchDesignById } from "../../hooks/search";

export const DrawingArticles = ({
  drawing,
}: {
  drawing: NormalizedDrawing;
}) => {
  const { opportunity } = useActiveProject();
  const { data } = useSearchDesignById(drawing.id);

  if (!data?.items) {
    return <Text>{t("prompt.no_articles")}</Text>;
  }

  return (
    <ProductList
      product={data}
      amount={data.value}
      currency={data.currency ?? opportunity?.currency}
    />
  );
};
